import PropTypes from 'prop-types';

// all of these values are enums
export default PropTypes.shape({
  alignment: PropTypes.string,
  hideRecommendatinos: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.string,
});
